import styled from 'styled-components'

const Card = styled.div`
  background: white;
  border-radius: 4px;
  padding: 16px;
`

export default Card
